<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="6">
          <h1>Gestión de Cursos</h1>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="openModal(null)">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nuevo Curso
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        class="mt-2"
        :items="coursesWithPrerequisite"
        :fields="fields"
        :loading="loading"
      >
        <template #cell(prerequisitoNombre)="data">
          <span v-if="data.value" class="text-info">
            <feather-icon icon="LinkIcon" size="14" />
            {{ data.value }}
          </span>
          <span v-else class="text-muted">-- Sin prerequisito --</span>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="data.value ? 'light-success' : 'light-danger'">
            {{ data.value ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button variant="gradient-primary" class="btn-icon" @click="openModal(data.item)">
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button variant="gradient-danger" class="btn-icon ml-1" @click="deleteCourse(data.item)">
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <course-modal
      :course-data="selectedCourse"
      :cursos="courses"
      @submit="handleModalSubmit"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge,
} from 'bootstrap-vue'
import CourseModal from '@/components/courses/CourseModal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import cursosService from '@/services/cursosService'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    CourseModal,
  },
  data() {
    return {
      fields: [
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'nombre', label: 'Nombre', sortable: true },
        { key: 'creditos', label: 'Créditos', sortable: true },
        { key: 'prerequisitoNombre', label: 'Prerequisito', sortable: true },
        { key: 'estado', label: 'Estado', sortable: true },
        { key: 'actions', label: 'Acciones' },
      ],
      courses: [],
      selectedCourse: null,
      loading: false,
    }
  },
  computed: {
    coursesWithPrerequisite() {
      return this.courses.map(curso => {
        const prerequisito = this.courses.find(c => c.cursoId === curso.cursoPrerrequisitoId)
        return {
          ...curso,
          prerequisitoNombre: prerequisito ? `${prerequisito.codigo} - ${prerequisito.nombre}` : null
        }
      })
    }
  },
  async mounted() {
    await this.loadCourses()
  },
  methods: {
    async loadCourses() {
      this.loading = true
      try {
        const response = await cursosService.getAll()
        this.courses = response
      } catch (error) {
        console.error('Error al cargar cursos:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al cargar los cursos',
          },
        })
      } finally {
        this.loading = false
      }
    },
    openModal(item) {
      this.selectedCourse = item ? { ...item } : null
      this.$bvModal.show('course-modal')
    },
    async handleModalSubmit(data) {
      try {
        if (data.cursoId) {
          // Actualizar curso existente
          await cursosService.update(data.cursoId, data)
        } else {
          // Crear nuevo curso
          await cursosService.create(data)
        }
        
        await this.loadCourses()
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operación Exitosa',
            icon: 'CheckIcon',
            variant: 'success',
            text: `El curso se ha ${data.cursoId ? 'actualizado' : 'creado'} correctamente.`,
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Error al procesar la operación',
          },
        })
      }
    },
    async deleteCourse(item) {
      this.$swal({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡elimínalo!',
        cancelButtonText: 'Cancelar',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await cursosService.delete(item.cursoId)
            await this.loadCourses()
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Eliminado',
                icon: 'TrashIcon',
                variant: 'success',
                text: 'El curso ha sido eliminado.',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Error al eliminar el curso',
              },
            })
          }
        }
      })
    },
  },
}
</script>
